const formatXAxisFilters = (activeFilter) => {
    switch (activeFilter) {
        case 'daily':
            return 'day';

        case 'hourly':
            return 'date_hour';
        default:
            break;
    }
};

export { formatXAxisFilters };
